module.exports = __webpack_public_path__ + "img/icon-google-play.2ec96608.png";